// @flow
import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Loading from '../Loading'
import './button.scss'

const SIZE_CLASS = {
  large: 'large',
  normal: 'normal',
  small: 'small'
}

const TYPE_CLASS = {
  primary: 'primary',
  secondary: 'secondary'
}

export default function Button(props) {
  const {
    size = 'normal',
    type = '',
    className,
    circle,
    full,
    onClick,
    fluid,
    disabled,
    loading,
    children
  } = props
  const rootClassName = ['button']
  const classObject = {
    [`button--${SIZE_CLASS[size]}`]: SIZE_CLASS[size],
    'button--disabled': disabled,
    [`button--${type}`]: TYPE_CLASS[type],
    'button--circle': circle,
    'button--full': full,
    'button--fluid': fluid
  }
  const loadingColor = type === 'primary' ? '#fff' : ''
  const loadingSize = size === 'small' ? 12 : 15
  let component
  if (loading) {
    component = (
      <div className="button-inner__icon">
        <Loading color={loadingColor} size={loadingSize} />
      </div>
    )
    rootClassName.push('button--icon')
  }
  return (
    <button
      disabled={disabled}
      className={cn(rootClassName, classObject, className)}
      onClick={onClick}>
      <div className="button-inner">
        {component}
        <span className="button-inner__text">{children}</span>
      </div>
    </button>
  )
}

Button.defaultProps = {
  size: 'normal',
  type: '',
  circle: false,
  full: false,
  fluid: false,
  loading: false,
  disabled: false,
  onClick: () => {},
  children: '',
  className: ''
  // Button props
}

Button.propTypes = {
  size: PropTypes.oneOf(['normal', 'large', 'small']),
  type: PropTypes.oneOf(['primary', 'secondary', '']),
  circle: PropTypes.bool,
  full: PropTypes.bool,
  fluid: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}
